import { useState } from 'react'

import { Icon, TextButton } from '@joor/design-system'
import styled from 'styled-components'

import DiscardChangesModal from './DiscardChangesModal'
import { useNavigationProducts } from 'features/Linesheets/Modals/ManageImagesModal/manageImagesModal.hooks'
import messages from 'features/Linesheets/Modals/ManageImagesModal/manageImagesModal.messages'
import useManageImagesStore from 'features/Linesheets/Modals/ManageImagesModal/store/useManageImagesStore'

interface StyleNavigationProps {
  disabled: boolean
}

const StyleNavigation = ({ disabled }: StyleNavigationProps) => {
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false)
  const [storedProductId, setStoredProductId] = useState('')
  const productId = useManageImagesStore((state) => state.productId)
  const isSavingImages = useManageImagesStore((state) => state.isSavingImages)
  const isUploadingImages = useManageImagesStore(
    (state) => state.isUploadingImages,
  )
  const setProductId = useManageImagesStore((state) => state.setProductId)
  const setSelectedImages = useManageImagesStore(
    (state) => state.setSelectedImages,
  )
  const setHasStyleColorChanges = useManageImagesStore(
    (state) => state.setHasStyleColorChanges,
  )
  const { loading, products } = useNavigationProducts()

  if (loading || products.length < 2) {
    return null
  }

  const currentProductIndex = products.findIndex((id) => id === productId)

  const handleProductChange = (productIdToFetch: string) => {
    setProductId({ productId: productIdToFetch })
    setSelectedImages({ selectedImages: new Map() })
    setHasStyleColorChanges({ hasStyleColorChanges: false })
  }

  return (
    <ActionsContainer>
      <StyledTextButton
        disabled={
          currentProductIndex <= 0 || isSavingImages || isUploadingImages
        }
        onClick={() => {
          if (currentProductIndex > 0) {
            if (!disabled) {
              setStoredProductId(products[currentProductIndex - 1])
              setIsConfirmModalOpen(true)
              return
            }
            handleProductChange(products[currentProductIndex - 1])
          }
        }}
      >
        <Icon iconName="chevron-left" iconSize="small" variant="ACTIVE" />{' '}
        {messages.previousStyle}
      </StyledTextButton>
      |
      <StyledTextButton
        disabled={
          currentProductIndex === products.length - 1 ||
          isSavingImages ||
          isUploadingImages
        }
        onClick={() => {
          if (currentProductIndex < products.length - 1) {
            if (!disabled) {
              setStoredProductId(products[currentProductIndex + 1])
              setIsConfirmModalOpen(true)
              return
            }
            handleProductChange(products[currentProductIndex + 1])
          }
        }}
      >
        {messages.nextStyle}{' '}
        <Icon iconName="chevron-right" iconSize="small" variant="ACTIVE" />
      </StyledTextButton>
      <DiscardChangesModal
        onConfirm={() => {
          setIsConfirmModalOpen(false)
          if (storedProductId) {
            handleProductChange(storedProductId)
            setStoredProductId('')
          }
        }}
        isModalOpen={isConfirmModalOpen}
        handleOnClose={() => {
          setIsConfirmModalOpen(false)
          setStoredProductId('')
        }}
        text={messages.unsavedChangesContent}
      />
    </ActionsContainer>
  )
}

const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-right: 8px;
`

const StyledTextButton = styled(TextButton)`
  & span {
    display: flex;
    align-items: center;
    gap: 2px;
  }
`

export default StyleNavigation
